import React from 'react';
import { Link } from 'react-router-dom';

const isSoloLanding = process.env.REACT_APP_SOLO_LANDING === 'true';
const homePath = isSoloLanding ? '/' : '/solo/dashboard';

export function SoloLegalLayout({ children, title }) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-gray-900 dark:to-gray-800">
      <header className="sticky top-0 z-40 border-b border-slate-200/60 bg-white/90 backdrop-blur-lg dark:bg-gray-900/80">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16 flex-wrap gap-2">
          <Link to={homePath} className="flex items-center gap-2">
            <img src="/brand/White logo on purple.png" alt="SEN-Education" className="h-9 w-9 rounded-lg" />
            <span className="font-bold text-lg text-purple-600 dark:text-purple-400">SEN-Education</span>
          </Link>
          <nav className="flex items-center gap-3 sm:gap-4 text-sm flex-wrap" aria-label="Main">
            <Link to={homePath} className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Home</Link>
            <Link to="/about" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">About</Link>
            <Link to="/contact" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Contact</Link>
            <Link to="/privacy" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Privacy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Terms</Link>
            <Link to="/security" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Security</Link>
            <Link to="/cookies" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Cookies</Link>
            <a href="https://sen-ed.co.uk" rel="noopener noreferrer" className="text-gray-600 hover:text-purple-600 dark:text-gray-300 dark:hover:text-purple-400">Go to our schools site</a>
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8" role="main">
        <article className="prose prose-slate dark:prose-invert max-w-none">
          {title && <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-8">{title}</h1>}
          {children}
        </article>
      </main>

      <footer className="border-t border-slate-200 dark:border-gray-700 bg-slate-50 dark:bg-gray-900/50 py-8 mt-12" role="contentinfo">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap gap-4 sm:gap-6 text-sm mb-4">
            <Link to="/privacy" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Privacy</Link>
            <Link to="/terms" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Terms</Link>
            <Link to="/security" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Security</Link>
            <Link to="/cookies" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Cookies</Link>
            <Link to="/about" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">About</Link>
            <Link to="/contact" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Contact</Link>
            <a href="https://sen-ed.co.uk" rel="noopener noreferrer" className="text-gray-600 hover:text-purple-600 dark:text-gray-400 dark:hover:text-purple-400">Go to our schools site</a>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400">
            <strong>SEN-Education</strong> is a product of The Send Tech Company Ltd (SEN-Ed is a trading name). Company number 16756429. Registered in England and Wales. Hosted on Google Firebase.
          </p>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
            We never ask for your password by email or phone. Log in only via <strong>app.sen-education.co.uk</strong> or your saved link.
          </p>
        </div>
      </footer>
    </div>
  );
}
